import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Alert, Spinner } from "reactstrap";
import { authenticatedFetch } from "../utils/apiUtils";

// Landing page for the dev-only "initiate transfer directly" link included in
// QR code emails when Testing:IncludeDirectTransferLinkInEmail is enabled.
// Reuses the same /transfers/request-qr endpoint and encrypted payload the
// mobile app posts after scanning the QR, so no new transfer-creation logic
// is needed here.
const TransferRequestLink = () => {
  const [status, setStatus] = useState("loading"); // loading | success | error
  const [message, setMessage] = useState("");

  useEffect(() => {
    const initiate = async () => {
      const params = new URLSearchParams(window.location.search);
      const code = params.get("code");
      if (!code) {
        setStatus("error");
        setMessage("No transfer code found in this link.");
        return;
      }

      try {
        const response = await authenticatedFetch("/transfers/request-qr", {
          method: "POST",
          body: JSON.stringify(code),
        });
        const data = await response.json().catch(() => ({}));
        if (response.ok) {
          setStatus("success");
          setMessage(data.message || "Transfer request created.");
        } else {
          setStatus("error");
          setMessage(data.message || "Failed to create transfer request.");
        }
      } catch (err) {
        console.error("Error initiating transfer from link:", err);
        setStatus("error");
        setMessage("Failed to create transfer request.");
      }
    };

    initiate();
  }, []);

  return (
    <div style={{ maxWidth: 480, margin: "80px auto", textAlign: "center" }}>
      {status === "loading" && (
        <>
          <Spinner color="primary" />
          <p className="mt-3">Initiating transfer request...</p>
        </>
      )}
      {status === "success" && (
        <>
          <Alert color="success">{message}</Alert>
          <Link to="/view-pending-transfers">View pending transfers</Link>
        </>
      )}
      {status === "error" && <Alert color="danger">{message}</Alert>}
    </div>
  );
};

export default TransferRequestLink;
